<template>
  <div class="border border-blue-300 shadow rounded-md p-4 max-w-sm w-full mx-auto">
    <div class="animate-pulse flex space-x-4">
      <div class="flex-1 space-y-6 py-1">
        <div class="h-2 bg-gray-100 rounded"></div>
        <div class="space-y-3">
          <div class="grid grid-cols-3 gap-4">
            <div class="h-2 bg-gray-100 rounded col-span-2"></div>
            <div class="h-2 bg-gray-100 rounded col-span-1"></div>
          </div>
          <div class="h-2 bg-gray-100 rounded"></div>
        </div>
      </div>
    </div>
    <div class="mt-2 text-center text-blue-300">Processing...</div>
  </div>
</template>
